import * as moment from 'moment';

/**
 * SG-8323 (Issue 8): every analytics chart built its fallback x-axis from the browser clock
 * (`new Date()`) while the series came from the server's window, which is anchored on the date
 * the request asked for. When the two disagree on "today" — a client on IST against a
 * server-side window — every label slid by a day: the ATC usage graph started at May 20 for
 * data the API had returned from May 19.
 *
 * Resolves the date an axis should be anchored to. Accepts a date-picker event
 * (`{ from: 'YYYY-MM-DD', type, count }`), a raw date string, or a Date — the analytics
 * components pass all three shapes. Falls back to now only when no usable date was supplied,
 * which preserves the previous behaviour for callers that have no date to offer.
 */
export function resolveAxisAnchorDate(input: any): Date {
  const requested =
    input && typeof input === 'object' && !(input instanceof Date) ? input.from : input;

  if ((typeof requested === 'string' && requested.trim() !== '') || requested instanceof Date) {
    const parsed = moment(requested);
    if (parsed.isValid()) {
      return parsed.toDate();
    }
  }

  return new Date();
}
